import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { dates } from "@/lib/dates";
import { guacHttpClient } from "@/lib/http";
import { DashboardInterview, HttpResponse } from "@/types";

// Hits same backend service as dashboard interviews pulls from

export function useGetInterviewsForCalendar({ userId }: { userId?: number }) {
  const companyId = useCurrentCompanyId();
  const jobId = useCurrentJobId();
  const { startDate, endDate } = dates.scheduleWindow();

  return useQuery({
    queryKey: [
      "interviews-calendar",
      companyId,
      jobId,
      userId,
      startDate,
      endDate,
    ],
    queryFn: async () => {
      const params = new URLSearchParams({
        scheduleStartDate: startDate,
        scheduleEndDate: endDate,
      });
      if (userId !== undefined) {
        params.set("userId", userId.toString());
      }
      const path = `companies/${companyId}/jobs/${jobId}/interviews/calendar?${params.toString()}`;
      const res = await guacHttpClient.get<
        DashboardInterview[],
        HttpResponse<DashboardInterview[]>
      >(path);
      return res.data;
    },
    enabled: !!companyId && !!jobId,
  });
}
